<div class="dialog-content">
    <div class="close-btn">
        <button mat-icon-button aria-label="close dialog" mat-dialog-close (click)="close()">
            X
        </button>
    </div>

    <p style="font-weight: 500; font-size: 16px;">Based on your responses your vehicle does not qualify to return without a pre-term inspection.  Please Proceed to schedule your pre-term inspection appointment.</p>
</div>